import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ResultButton from './ResultButton'

const GoToSampleDashboard = ({ fileId, sampleName }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/libra/sample/${fileId}/${sampleName}`)
  }

  return (
    <Tooltip title="QC dashboard" arrow>
      <ResultButton onClick={handleClick}>QC</ResultButton>
    </Tooltip>
  )
}

export default GoToSampleDashboard
